import React, { useState, useEffect } from "react";
import { UseColumns } from "../hooks/UseColumns";
import { SwitchArrow } from "./SwitchArrow";
import { RightArrow } from "./RightArrow";

export const Tab = ({
  btnActive,
  className,
  from,
  id,
  oneWayTrip,
  returnTrip,
  setBtnActive,
  setCurrentColumnsData,
  setCurrentDataTable,
  to,
}) => {
  const [isSwitched, setIsSwitched] = useState(false);

  const isActive = id === btnActive;
  const columns = UseColumns(
    isSwitched ? to : from,
    isSwitched ? from : to,
    isSwitched ? returnTrip : oneWayTrip
  );

  useEffect(() => {
    if (isActive) {
      setCurrentColumnsData(columns);
    }
  }, [columns, isActive]);

  useEffect(() => {
    if (isActive) {
      setCurrentDataTable(isSwitched ? returnTrip : oneWayTrip);
    }
  }, [isSwitched, isActive]);

  const onClick = () => {
    setBtnActive(id);
  };

  const switchDestination = () => {
    if (returnTrip.length  === 0) return;

    setIsSwitched(!isSwitched);
  };

  return (
    <button
      className={`p-btn ${
        isActive ? "active-tab" : "inactive-tab"
      } ${className}`}
      onClick={onClick}
      id={id}
    >
      <h4
        style={{ color: isActive ? "#FFF" : "#616972" }}
        className="text-15-md"
      >
        {isSwitched ? to : from}
      </h4>
      {!isActive ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="w-16-md"
        >
          <path
            d="M4 12H20M20 12L14 6M20 12L14 18"
            stroke="#616972"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ) : (
        <button className="switch-btn" onClick={switchDestination}>
          {returnTrip.length > 0 ? <SwitchArrow /> : <RightArrow />}
        </button>
      )}

      <h4
        style={{ color: isActive ? "#FFF" : "#616972" }}
        className="text-15-md"
      >
        {isSwitched ? from : to}
      </h4>
    </button>
  );
};
